<template>
  <div class="bg">
    <Header1></Header1>
    <div class="bg_waper">
      <el-tabs v-model="activeName"
               type="card">
        <el-tab-pane label="手机号码重置密码"
                     name="first">
          <div class="content">
            <div class="alertMsg">
              <h6 style="padding-top: 5px;margin-left: 10px">提示:</h6>
              <p style="font-size: 12px;margin-left: 20px">我们需要验证你的手机号码，验证通过后，你可以通过重置密码进行登录。</p>
            </div>
            <div class="RegisterItem">
              <label class="RegisterLabel">用户名称：</label>
              <input v-model="username"
                     type="text"
                     class="RegisterInput"
                     placeholder="请输入用户名" />
            </div>
            <div class="RegisterItem">
              <label class="RegisterLabel">手机号：</label>
              <input v-model="phoneNumber"
                     class="RegisterInput"
                     type="text"
                     placeholder="请输入手机号" />
            </div>
            <div class="RegisterItemCode">
              <label class="RegisterLabel">验证码：</label>
              <input class="RegisterInputCode"
                     v-model="inputCode"
                     @blur="checkUser"
                     type="text"
                     placeholder="请输入验证码" />
              <span v-show="sendAuthCode"
                    class="getVerificationCode"
                    @click="getAuthCode">获取验证码</span>
              <span v-show="!sendAuthCode"> <span>{{auth_time}} </span> 秒之后重新发送验证码</span>
            </div>
            <div class="RegisterItem">
              <label class="RegisterLabel">新密码：</label>
              <input v-model="password"
                     class="RegisterInput"
                     type="password"
                     placeholder="密码不能含有非法字符，长度在4-10之间" />
            </div>
            <div class="RegisterItem">
              <label class="RegisterLabel">确认密码：</label>
              <input @blur="validateRePassword"
                     v-model="rePassword"
                     class="RegisterInput"
                     type="password"
                     placeholder="请再次输入密码" />
            </div>
            <div class="submitBtn"
                 style="cursor: pointer;"
                 @click="onSubmit">提交</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="邮箱重置密码"
                     name="second">
          <div class="content">
            <div class="alertMsg">
              <h6 style="padding-top: 5px;margin-left: 10px">提示:</h6>
              <p style="font-size: 12px;margin-left: 20px">我们需要验证你的邮箱，验证通过后，你可以通过重置密码进行登录。</p>
            </div>
            <div class="RegisterItem">
              <label class="RegisterLabel">用户名称：</label>
              <input v-model="username"
                     type="text"
                     class="RegisterInput"
                     placeholder="请输入用户名" />
            </div>
            <div class="RegisterItem">
              <label class="RegisterLabel">邮箱：</label>
              <input v-model="email"
                     class="RegisterInput"
                     type="text"
                     placeholder="请输入邮箱" />
            </div>
            <div class="RegisterItemCode">
              <label class="RegisterLabel">验证码：</label>
              <input class="RegisterInputCode"
                     v-model="inputEmailCode"
                     @blur="checkUserEmail"
                     type="text"
                     placeholder="请输入验证码" />
              <span v-show="sendAuthCode"
                    class="getVerificationCode"
                    @click="getEmailCode">获取验证码</span>
              <span v-show="!sendAuthCode"> <span>{{auth_time}} </span> 秒之后重新发送验证码</span>
            </div>
            <div class="RegisterItem">
              <label class="RegisterLabel">新密码：</label>
              <input v-model="password"
                     class="RegisterInput"
                     type="password"
                     placeholder="密码不能含有非法字符，长度在4-10之间" />
            </div>
            <div class="RegisterItem">
              <label class="RegisterLabel">确认密码：</label>
              <input @blur="validateRePassword"
                     v-model="rePassword"
                     class="RegisterInput"
                     type="password"
                     placeholder="请再次输入密码" />
            </div>
            <div class="submitBtn"
                 style="cursor: pointer;"
                 @click="onEmailSubmit">提交</div>
          </div>
        </el-tab-pane>
      </el-tabs>

    </div>
  </div>
</template>

<script>
import Header1 from '../components/Header1.vue';
import { request } from '../API/ApiUrl';
import { Message } from 'element-ui'
export default {
  components: {
    Header1,
  },
  data () {
    return {
      sendAuthCode: true,
      auth_time: 60,
      identifyingCode: "",
      inputCode: "",
      inputEmailCode: "",
      username: "",
      phoneNumber: "",
      password: "",
      rePassword: "",
      thisData: false,
      thatData: false,
      activeName: "first",
      email: "",
      emailCode: ""
    }
  },
  mounted () {
    this.addVisit();
  },
  methods: {
    //增加点击量
    addVisit () {
      request('/apiVisit/addVisitData', { "module": 107 }).then(res => {

      })
    },
    //获取验证码倒计时
    time () {
      this.auth_time = 60;
      this.sendAuthCode = false;
      let auth_timetimer = setInterval(() => {
        this.auth_time--;
        if (this.auth_time <= 0) {
          this.sendAuthCode = true;
          clearInterval(auth_timetimer);
        }
      }, 1000);
    },
    //判断两次密码是否一致
    validateRePassword () {
      if (this.rePassword == '') {
        Message.warning('请重复输入密码');
        return;
      }
      if (this.password !== this.rePassword) {
        Message.warning('两次输入的密码不相同');
        return;
      }
    },
    //手机获取验证码
    getAuthCode () {
      if (this.phoneNumber != "") {
        request('/api/sendIdentifyingCode', { phone: this.phoneNumber }).then(res => {
          if (res.code == 200) {
            this.identifyingCode = res.identifyingCode;
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        })
        this.time()
      }
    },
    //获取邮箱验证码
    getEmailCode () {
      if (this.email != "") {
        request('/api/sendEmailIdentifyingCode', { email: this.email }).then(res => {
          //console.log(res);
          if (res.code === 200) {
            this.emailCode = res.identifyingCode
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        });
        this.time()
      }
    },
    //手机验证提交
    onSubmit () {
      if (this.thisData) {
        request('/api/resetPassword', { username: this.username, newPassword: this.password }).then(res => {
          if (res.code === 200) {
            Message.success('重置成功，前往登录页面');
            this.$router.push("/login?type=1");
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        })
      }
    },
    //邮箱验证提交
    onEmailSubmit () {
      if (this.thatData) {
        request('/api/resetPassword', { username: this.username, newPassword: this.password }).then(res => {
          if (res.code === 200) {
            this.$router.push("/login?type=1");
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        })
      }
    },
    checkUser () {
      //判断手机验证码
      if (this.identifyingCode != this.inputCode) {
        message: "请输入正确验证码"
        return;
      }
      //判断用户是否存在
      request('/api/checkUserIsExist', { username: this.username, type: 2, condition: this.phoneNumber }).then(res => {
        if (res.code === 200) {
          this.thisData = true
        } else {
          message: "用户不存在";
          return false
        }
      });
    },
    checkUserEmail () {
      //判断邮箱验证码
      if (this.emailCode != this.inputEmailCode) {
        message: "请输入正确验证码"
        return;
      }
      //判断用户是否存在
      request('/api/checkUserIsExist', { username: this.username, type: 1, condition: this.email }).then(res => {
        if (res.code === 200) {
          this.thatData = true
        } else {
          message: "用户不存在";
          return false
        }
      });

    }
  }
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.bg {
  width: 100%;
  height: 100%;
  background: url("../assets/Img/bgimage.jpg") 0 0 no-repeat;
}
.bg_waper {
  width: 29%;
  height: 52%;
  margin: 5% auto;
  background-color: #ffffff;
}
.alertMsg {
  width: 95%;
  // height: 60px;
  padding-right: 10px;
  padding-bottom: 10px;
  margin: 2% auto;
  color: #e29612;
  background-color: #f3eec2;
  border-radius: 5px;
  line-height: 25px;
}
.RegisterItem {
  font-size: 13px;
  width: 100%;
  margin: 10px auto;
  color: #f2f0f0;
}
.RegisterInput {
  width: 60%;
  border: 1px solid #dcd9d9;
  border-radius: 2px;
  height: 25px;
  padding-left: 10px;
}
.RegisterInput::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #aab2bd;
  /* placeholder字体大小  */
  font-size: 12px;
  /* placeholder位置  */
  text-align: left;
}
.RegisterInputCode::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #aab2bd;
  /* placeholder字体大小  */
  font-size: 12px;
  /* placeholder位置  */
  text-align: left;
}
.RegisterInputCode {
  width: 22%;
  border: 1px solid #dcd9d9;
  border-radius: 2px;
  height: 25px;
  padding-left: 10px;
}
.RegisterLabel {
  color: #077882;
  width: 25%;
  display: inline-block;
  text-align: right;
}
.RegisterItemCode {
  font-size: 13px;
  width: 100%;
  margin: 5px auto;
}
.RegisterItemCode .getVerificationCode:hover {
  cursor: pointer;
  color: #3385ff;
}
.RegisterItemCode span {
  margin-left: 5px;
}
.submitBtn {
  height: 40px;
  width: 120px;
  margin: 15px auto;
  background: #2371c7;
  color: #f1f1f2;
  font-size: 15px;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
}
</style>